// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
import { convertLITsToLIs, convertSLIsToLITs, getListTokenRaw } from './List.helpers';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class ListAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `ListModule` to the `ListToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        // TMP
        // this.validate(content, {
        //   items: {
        //     presence: true,
        //     type: 'array'
        //   },
        //   meta: {
        //     presence: true
        //   },
        //   'meta.isLoose': {
        //     presence: true,
        //     type: 'boolean'
        //   },
        //   'meta.isOrdered': {
        //     presence: true,
        //     type: 'boolean'
        //   },
        //   'meta.start': {
        //     presence: true,
        //     type: { type: (value: unknown) => typeof value === 'string' || typeof value === 'number' }
        //   }
        // })
        let { items, meta } = content;
        const updateItems = (items) => {
            return items.map(item => {
                const _item = { ...item };
                _item.meta = {
                    isOrdered: false,
                    isLoose: false,
                    start: 1,
                    ...item.meta
                };
                if (item.children) {
                    item.children = updateItems(item.children);
                }
                return _item;
            });
        };
        items = updateItems(items);
        const token = {
            content: convertSLIsToLITs(items),
            meta: {
                // @ts-expect-error
                isLoose: false,
                // @ts-expect-error
                isOrdered: false,
                // @ts-expect-error
                start: '',
                // This line will overwrite any possible duplicates.
                ...meta
            },
            type: TokenType.List
        };
        token.raw = getListTokenRaw(token.content, typeof meta !== 'undefined' ? !!meta.isOrdered : false);
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `ListToken` to the `ListModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content: children, meta } = token;
        this.validate(children, { presence: true, type: 'array' }, true);
        this.validate(meta, {
            isLoose: {
                presence: true,
                type: 'boolean'
            },
            isOrdered: {
                presence: true,
                type: 'boolean'
            },
            start: {
                presence: true,
                type: { type: (value) => typeof value === 'string' || typeof value === 'number' }
            }
        });
        return {
            ...getModuleBase(),
            content: {
                items: convertLITsToLIs(children),
                meta: meta
            },
            driver: ModuleDriver.List
        };
    }
}
